export enum ExtensionDisplayType {
	IconAndText = 0,
	Icon = 1,
	Text = 2
}